/* eslint-disable no-underscore-dangle */
import isServer from './is-server'

/* globals window */
const getGlobals = () => (isServer() ? process.env : window.__GLOBALS__)

export default getGlobals
